export default "__VITE_ASSET__B8n61aR1__"